const DEFAULT_PARENT_COLUMN_ID = 'scrollableDiv';

export default {
  DEFAULT_PARENT_COLUMN_ID,
};
